<template>
  <button class="xt-button" :disabled="disabled" :class="extraClass" @click="handleClick">
    <slot/>
  </button>
</template>
<script>
  export default {
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      isCube: {
        type: Boolean,
        default: false
      },
      //  primary, success
      type: {
        type: String,
        default: ''
      }
    },
    computed: {
      extraClass() {
        let classes = ''
        if (this.isCube) {
          if (this.type === 'primary') {
            classes = 'cube primary '
          } else {
            classes = 'cube none '
          }
        }
        if (this.disabled) {
          classes += 'disabled'
        }
        return classes
      }
    },
    methods: {
      handleClick(evt) {
        this.$emit('click', evt)
      }
    }
  }
</script>
<style scoped lang="less">
  @import '../css/mobile.less';

  .xt-button {
    height: 38px;
    line-height: 38px;
    background: #6496DB;
    border-radius: 4px;
    margin-left: 21px;
    color: #FFFFFF;
    text-align: center;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    border: 1px solid #6496DB;
    user-select: none;
    display: block;
    &:hover {
      background: #74A6EB;
      border-color: #74A6EB;
    }
    &.border {
      background: #FFFFFF;
      color: #6496DB;
      &:hover {
        background: #FFFFFF;
        border-color: #74A6EB;
        color: #74A6EB;
      }
    }
    &.disabled {
      cursor: not-allowed;
      background: @disable-button-color;
      border-color: @disable-button-color;
      color: @white-text-color;
    }
  }
</style>